import { t } from '@lingui/core/macro';
import { CameraErrorAlert } from './CameraErrorAlert';
import { Button } from './ui/button';

/** 'network': the GPS fix failed and the Wi-Fi/cell one is pending. */
export type WaitingForLocation = false | 'gps' | 'network';

interface PhotoProcessingOverlayProps {
  waitingForLocation: WaitingForLocation;
  error: string | null;
  onClose: () => void;
  /** The photo was lost to a reload. The button opens the camera instead of dismissing. */
  recover?: boolean;
}

/**
 * Covers the step screen between the native camera returning a photo and the
 * upload starting, or shows why the photo could not be used.
 */
export function PhotoProcessingOverlay({
  waitingForLocation,
  error,
  onClose,
  recover = false,
}: PhotoProcessingOverlayProps) {
  return (
    <div className="capture-overlay bg-black/70 flex items-center justify-center">
      <div className="text-white text-center px-4">
        {error ? (
          <>
            <CameraErrorAlert className="mx-auto mb-4">{error}</CameraErrorAlert>
            <Button onClick={onClose} variant="secondary">
              {recover ? t`Retake Photo` : t`Close`}
            </Button>
          </>
        ) : (
          <>
            <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-white mx-auto mb-4" />
            <p className="text-lg font-medium">
              {waitingForLocation === 'gps'
                ? t`Getting GPS position...`
                : waitingForLocation === 'network'
                  ? t`Still getting GPS position. Move outdoors or near a window.`
                  : t`Processing photo...`}
            </p>
          </>
        )}
      </div>
    </div>
  );
}
